import React, { FC } from 'react'
import { Collapse } from 'components/Collapse'

import { FilterWrapper, FilterList } from '..'

import { FILTER_FIELDS, USER_TYPES_OPTIONS } from 'shared/consts/filter'

import { FilterUsersProps } from './FilterUsers.props'

const FilterUsers: FC<FilterUsersProps> = ({
  zoneOptions,
  spaceOptions,
  rolesOptions,
  filterEntities,
  initialValues,
  defaultValue,
  usersTotal
}) => {
  return (
    <FilterWrapper
      selectionLabels={{
        role_id: rolesOptions,
        label_id: zoneOptions,
        space_id: spaceOptions,
        is_external: USER_TYPES_OPTIONS
      }}
      reverseDirection
      total={`${usersTotal} users`}
      filterEntities={filterEntities}
      initialValues={initialValues}
      defaultValue={defaultValue}
      render={({ updateValue, resetValues, shouldBeReset, values }) => {
        const updateZoneSpaceValue = (id: string, type?: string) => {
          if (type) {
            updateValue(type === FILTER_FIELDS.LABELS ? FILTER_FIELDS.SPACES : FILTER_FIELDS.LABELS)('all')
            updateValue(type)(id)
          } else {
            updateValue(FILTER_FIELDS.LABELS)('all')
            updateValue(FILTER_FIELDS.SPACES)('all')
          }
        }
        return (
          <Collapse list={[
            {
              title: 'Select Type',
              id: '1',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.EXTERNAL)}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All types',
                      value: 'all'
                    },
                    ...USER_TYPES_OPTIONS
                  ]}
                  initialValue={values.is_external}
                  defaultValue={defaultValue.is_external}
                  reset={shouldBeReset}
                />),
              expand: false
            },
            {
              title: 'Select Role',
              id: '2',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.ROLES)}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All roles',
                      value: 'all'
                    },
                    ...rolesOptions
                  ]}
                  initialValue={values.role_id}
                  defaultValue={defaultValue.role_id}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            }, {
              title: 'Select Zone / Spaces',
              id: '3',
              content: (
                <FilterList
                  onSelect={updateZoneSpaceValue}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All zone / spaces',
                      value: 'all'
                    },
                    ...spaceOptions,
                    ...zoneOptions
                  ]}
                  initialValue={values[FILTER_FIELDS.LABELS]}
                  defaultValue={defaultValue.label_id}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            }
          ]}>
          </Collapse>
        )
      }}
    />
  )
}

export default FilterUsers
